import { useEffect } from 'react';
import { Params, useLocation, useMatches, useParams } from 'react-router-dom';

import { trackVirtualPageView } from '@fora-monorepo/webapp-analytics';

import { getLastMatchingTitle } from '../../common/utils';
import { useTypedTranslation } from '../../i18n/i18n';
import { policyNumberParam } from '../../router/paths';

export const useTrackPageViews = () => {
  const matches = useMatches();
  const { t } = useTypedTranslation();
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    const pathToTrack = getPathToTrack(params, location.pathname);
    const pageTitle = getLastMatchingTitle(matches, t).title;
    trackVirtualPageView({ urlPath: pathToTrack, pageTitle });

    // Only track when location changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
};

// replaces sensitive data in URL, if present
export const getPathToTrack = (params: Readonly<Params<string>>, pathname: string) => {
  if (Object.keys(params).length === 0) {
    return pathname;
  }

  let maskedPath = pathname;

  if (params[policyNumberParam]) {
    maskedPath = maskedPath.replace(params[policyNumberParam], `***${policyNumberParam}***`);
  }

  return maskedPath;
};
